// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageBubble-module__font-s-10___PnP2n {
  font-size: 10px !important;
}

.MessageBubble-module__font-s-12___PsGxA {
  font-size: 12px !important;
}

.MessageBubble-module__font-s-13___H3NKV {
  font-size: 13px !important;
}

.MessageBubble-module__font-s-14___CuJrk {
  font-size: 14px !important;
}

.MessageBubble-module__font-s-15___oa1QJ {
  font-size: 15px !important;
}

.MessageBubble-module__font-s-16___Q58rS {
  font-size: 16px !important;
}

.MessageBubble-module__font-s-18___MFUlo {
  font-size: 18px !important;
}

.MessageBubble-module__font-s-20___l6zw8 {
  font-size: 20px !important;
}

.MessageBubble-module__font-s-22___XC7aK {
  font-size: 22px !important;
}

.MessageBubble-module__font-s-28___P7k6Y {
  font-size: 28px !important;
}

.MessageBubble-module__font-w-400___JQbyo {
  font-weight: 400 !important;
}

.MessageBubble-module__font-w-500___BG8HU {
  font-weight: 500 !important;
}

.MessageBubble-module__font-w-600___CyH3R {
  font-weight: 600 !important;
}

.MessageBubble-module__font-w-700___kjWj4 {
  font-weight: 700 !important;
}

.MessageBubble-module__p-5___uHPw5 {
  padding: 5px !important;
}

.MessageBubble-module__p-12___Rvui9 {
  padding: 12px !important;
}

.MessageBubble-module__p-16___aLfNV {
  padding: 16px !important;
}

.MessageBubble-module__p-30___E2zzm {
  padding: 30px !important;
}

.MessageBubble-module__p-b-0___csY4D {
  padding-bottom: 0 !important;
}

.MessageBubble-module__p-b-5___Ay83P {
  padding-bottom: 5px !important;
}

.MessageBubble-module__p-b-10___Ci4n1 {
  padding-bottom: 10px !important;
}

.MessageBubble-module__p-b-12___ufi9p {
  padding-bottom: 12px !important;
}

.MessageBubble-module__p-b-16___bh7le {
  padding-bottom: 16px !important;
}

.MessageBubble-module__p-b-18___MwrQ5 {
  padding-bottom: 18px !important;
}

.MessageBubble-module__p-b-20___zLriG {
  padding-bottom: 20px !important;
}

.MessageBubble-module__p-b-25___R47Ws {
  padding-bottom: 25px !important;
}

.MessageBubble-module__p-b-30___DonCt {
  padding-bottom: 30px !important;
}

.MessageBubble-module__p-b-50___gvyEx {
  padding-bottom: 50px !important;
}

.MessageBubble-module__p-t-0___qyfzx {
  padding-top: 0 !important;
}

.MessageBubble-module__p-t-12___Aau_l {
  padding-top: 12px !important;
}

.MessageBubble-module__p-t-16___W2kj7 {
  padding-top: 16px !important;
}

.MessageBubble-module__p-t-18___eE0UV {
  padding-top: 18px !important;
}

.MessageBubble-module__p-t-20___Zr1HM {
  padding-top: 20px !important;
}

.MessageBubble-module__p-t-30___kvPGq {
  padding-top: 30px !important;
}

.MessageBubble-module__p-t-40___kv7IQ {
  padding-top: 40px !important;
}

.MessageBubble-module__p-t-50___GYbcP {
  padding-top: 50px !important;
}

.MessageBubble-module__p-l-20___UL2bU {
  padding-left: 20px !important;
}

.MessageBubble-module__p-l-30___ISRym {
  padding-left: 30px !important;
}

.MessageBubble-module__p-l-40___arFI6 {
  padding-left: 40px !important;
}

.MessageBubble-module__p-r-16___ctiYF {
  padding-right: 16px !important;
}

.MessageBubble-module__p-r-20____Mn25 {
  padding-right: 20px !important;
}

.MessageBubble-module__p-r-30___gggJE {
  padding-right: 30px !important;
}

.MessageBubble-module__p-r-50___vqW2b {
  padding-right: 50px !important;
}

.MessageBubble-module__p-r-60___Rk70M {
  padding-right: 60px !important;
}

.MessageBubble-module__m-b-1___gI0vX {
  margin-bottom: 1px !important;
}

.MessageBubble-module__m-b-2___WZVNJ {
  margin-bottom: 2px !important;
}

.MessageBubble-module__m-b-6___Y6Wl5 {
  margin-bottom: 6px !important;
}

.MessageBubble-module__m-b-8___lv5PK {
  margin-bottom: 8px !important;
}

.MessageBubble-module__m-b-10___LESm7 {
  margin-bottom: 10px !important;
}

.MessageBubble-module__m-b-14___sFwvv {
  margin-bottom: 14px !important;
}

.MessageBubble-module__m-b-16___ZpyGl {
  margin-bottom: 16px !important;
}

.MessageBubble-module__m-b-20____dda5 {
  margin-bottom: 20px !important;
}

.MessageBubble-module__m-b-22___ZzT7y {
  margin-bottom: 22px !important;
}

.MessageBubble-module__m-b-24___nR6fT {
  margin-bottom: 24px !important;
}

.MessageBubble-module__m-b-30___b85za {
  margin-bottom: 30px !important;
}

.MessageBubble-module__m-b-32___kNtyi {
  margin-bottom: 32px !important;
}

.MessageBubble-module__m-b-40___NS6_I {
  margin-bottom: 40px !important;
}

.MessageBubble-module__m-t-2___cv9en {
  margin-top: 2px !important;
}

.MessageBubble-module__m-t-3___wvEAW {
  margin-top: 3px !important;
}

.MessageBubble-module__m-t-4___mCAiE {
  margin-top: 4px !important;
}

.MessageBubble-module__m-t-5___i1JUi {
  margin-top: 5px !important;
}

.MessageBubble-module__m-t-8___KoQRw {
  margin-top: 8px !important;
}

.MessageBubble-module__m-t-10___h4b6x {
  margin-top: 10px !important;
}

.MessageBubble-module__m-t-15___TW4HY {
  margin-top: 15px !important;
}

.MessageBubble-module__m-t-16___UFSGW {
  margin-top: 16px !important;
}

.MessageBubble-module__m-t-20___hONpb {
  margin-top: 20px !important;
}

.MessageBubble-module__m-t-22___jkTfH {
  margin-top: 22px !important;
}

.MessageBubble-module__m-t-30___lB1u5 {
  margin-top: 30px !important;
}

.MessageBubble-module__m-t-32___zu6Oq {
  margin-top: 32px !important;
}

.MessageBubble-module__m-l-auto___XkV7p {
  margin-left: auto !important;
}

.MessageBubble-module__m-l-4___wM23X {
  margin-left: 4px !important;
}

.MessageBubble-module__m-l-5___wW4qA {
  margin-left: 5px !important;
}

.MessageBubble-module__m-l-6___spLqw {
  margin-left: 6px !important;
}

.MessageBubble-module__m-l-8___rD8XG {
  margin-left: 8px !important;
}

.MessageBubble-module__m-l-10___UmGYH {
  margin-left: 10px !important;
}

.MessageBubble-module__m-l-16___tvmAc {
  margin-left: 16px !important;
}

.MessageBubble-module__m-l-20___O_9wT {
  margin-left: 20px !important;
}

.MessageBubble-module__m-l-24___xNceL {
  margin-left: 24px !important;
}

.MessageBubble-module__m-l-30___CayEu {
  margin-left: 30px !important;
}

.MessageBubble-module__m-l-35___l5nOy {
  margin-left: 35px !important;
}

.MessageBubble-module__m-l-40___OR_1Q {
  margin-left: 40px !important;
}

.MessageBubble-module__m-r-8___dWpat {
  margin-right: 8px !important;
}

.MessageBubble-module__m-r-10___bEfOq {
  margin-right: 10px !important;
}

.MessageBubble-module__m-r-16___vH8pf {
  margin-right: 16px !important;
}

.MessageBubble-module__m-r-20___xeZjk {
  margin-right: 20px !important;
}

.MessageBubble-module__m-r-24___cGY1H {
  margin-right: 24px !important;
}

.MessageBubble-module__m-r-30___cmWse {
  margin-right: 30px !important;
}

.MessageBubble-module__m-r-40___iFLHp {
  margin-right: 40px !important;
}

.MessageBubble-module__border-r-3___L46Af {
  border-radius: 3px !important;
}

.MessageBubble-module__border-r-4___gl1JN {
  border-radius: 4px !important;
}

.MessageBubble-module__border-r-6___yi0zJ {
  border-radius: 6px !important;
}

.MessageBubble-module__border-r-10___i35Y0 {
  border-radius: 10px !important;
}

.MessageBubble-module__border-r-12___DSHjP {
  border-radius: 12px !important;
}

.MessageBubble-module__border-r-16___fw5Wd {
  border-radius: 16px !important;
}

.MessageBubble-module__border-r-50___X9P1V {
  border-radius: 50% !important;
}

.MessageBubble-module__primary-border___bsMF0 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MessageBubble-module__primary-border-b___QCOvj {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MessageBubble-module__primary-border-t___fNz09 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MessageBubble-module__primary-border-l___jtMIp {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MessageBubble-module__primary-border-r___BbYYm {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MessageBubble-module__secondary-border___lJPHI {
  border: 1px solid #637768;
}

.MessageBubble-module__secondary-border-b___n1feG {
  border-bottom: 1px solid #637768;
}

.MessageBubble-module__secondary-border-t___n8bsg {
  border-top: 1px solid #637768;
}

.MessageBubble-module__secondary-border-l___jol4w {
  border-left: 1px solid #637768;
}

.MessageBubble-module__secondary-border-r___AU688 {
  border-right: 1px solid #637768;
}

.MessageBubble-module__gap-0___Ed4Wm {
  gap: 0 !important;
}

.MessageBubble-module__gap-2___UMqlM {
  gap: 2px !important;
}

.MessageBubble-module__gap-4___Bk16J {
  gap: 4px !important;
}

.MessageBubble-module__gap-5___beqev {
  gap: 5px !important;
}

.MessageBubble-module__gap-6___B7bWl {
  gap: 6px !important;
}

.MessageBubble-module__gap-8___AtUo5 {
  gap: 8px !important;
}

.MessageBubble-module__gap-10___rXvs_ {
  gap: 10px !important;
}

.MessageBubble-module__gap-12___m3u9k {
  gap: 12px !important;
}

.MessageBubble-module__gap-14___ppx6q {
  gap: 14px !important;
}

.MessageBubble-module__gap-16___h0M8s {
  gap: 16px !important;
}

.MessageBubble-module__gap-18___LPXVt {
  gap: 18px !important;
}

.MessageBubble-module__gap-20___ihpcU {
  gap: 20px !important;
}

.MessageBubble-module__gap-24___QnIQP {
  gap: 24px !important;
}

.MessageBubble-module__gap-26___siZPQ {
  gap: 26px !important;
}

.MessageBubble-module__gap-30___vzMkc {
  gap: 30px !important;
}

.MessageBubble-module__gap-32___DQJcp {
  gap: 32px !important;
}

.MessageBubble-module__gap-40___YZMWa {
  gap: 40px !important;
}

.MessageBubble-module__gap-50___hK6D8 {
  gap: 50px !important;
}

.MessageBubble-module__flex-1___qgToY {
  flex: 1;
}

.MessageBubble-module__flex-none___mK3f3 {
  flex: none !important;
}

.MessageBubble-module__flex-column___HYjzF {
  display: flex;
  flex-direction: column !important;
}

.MessageBubble-module__flex-row___hOquD {
  display: flex;
  flex-direction: row !important;
}

.MessageBubble-module__vertically-centered___srWQ9 {
  display: flex;
  align-items: center !important;
}

.MessageBubble-module__horizontally-centered___BChgs {
  display: flex;
  justify-content: center !important;
}

.MessageBubble-module__horizontally-end___z0HWk {
  display: flex;
  justify-content: end !important;
}

.MessageBubble-module__vertically-start___x5hgq {
  display: flex;
  align-items: start !important;
}

.MessageBubble-module__space-between___q32xM {
  display: flex;
  justify-content: space-between !important;
}

.MessageBubble-module__flex-wrap___W7IQX {
  flex-wrap: wrap !important;
}

.MessageBubble-module__height-100___iyA5D {
  height: 100%;
}

.MessageBubble-module__width-50___d4Fv7 {
  width: 50% !important;
}

.MessageBubble-module__width-100___Vc0ys {
  width: 100%;
}

.MessageBubble-module__cursor-pointer___Ht8ve {
  cursor: pointer;
}

.MessageBubble-module__cursor-not-allowed___LlyKy {
  cursor: not-allowed !important;
}

.MessageBubble-module__absolute-centered___Cao_G {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MessageBubble-module__absolute___neGOw {
  position: absolute;
}

.MessageBubble-module__relative___j85oN {
  position: relative;
}

.MessageBubble-module__fixed___Dshho {
  position: fixed;
}

.MessageBubble-module__visible___g7NfV {
  opacity: 1;
}

.MessageBubble-module__invisible___ccx9s {
  opacity: 0;
}

.MessageBubble-module__col-90___Hmjkw {
  width: 90% !important;
}

.MessageBubble-module__col-auto___UFPOv {
  width: auto !important;
}

.MessageBubble-module__medical-tabs___UTThH {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MessageBubble-module__medical-table-new___d3pAz {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MessageBubble-module__medical-table-new___d3pAz:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MessageBubble-module__medical-table-new___d3pAz::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MessageBubble-module__medical-table-new___d3pAz::-webkit-scrollbar-track {
  display: none;
}
.MessageBubble-module__medical-table-new___d3pAz.MessageBubble-module__no-pagination___rBVkx {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MessageBubble-module__medical-table-new___d3pAz.MessageBubble-module__no-pagination___rBVkx:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MessageBubble-module__medical-table-new___d3pAz.MessageBubble-module__no-pagination___rBVkx::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MessageBubble-module__medical-table-new___d3pAz.MessageBubble-module__no-pagination___rBVkx::-webkit-scrollbar-track {
  display: none;
}

.MessageBubble-module__medical-table-empty___Ga1ld {
  padding: 14px 40px !important;
}

.MessageBubble-module__icon-btn___yaTsA {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MessageBubble-module__search-icon___h6UKf {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MessageBubble-module__disable-select___DBxdn {
  user-select: none;
}

.MessageBubble-module__break-word___aD4j1 {
  word-break: break-word;
}

.MessageBubble-module__popup-clear-btn___RKkLr {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MessageBubble-module__scroll-m-b-20___bgkwZ {
  scroll-margin-bottom: 20px;
}

.MessageBubble-module__container___fcY52 {
  display: flex;
  padding: 0 40px;
  align-items: baseline;
}
.MessageBubble-module__container___fcY52.MessageBubble-module__right___HQtPY {
  flex-direction: row-reverse;
  align-items: flex-start;
}
.MessageBubble-module__container___fcY52 .MessageBubble-module__icon___PgfpR {
  width: 39px;
  height: 39px;
  align-self: flex-end;
}
.MessageBubble-module__container___fcY52 .MessageBubble-module__wrapper___zHOQZ {
  max-width: 50%;
}
.MessageBubble-module__container___fcY52 .MessageBubble-module__wrapper___zHOQZ .MessageBubble-module__bubble___bU_Zr {
  color: #375844;
  background-color: #fdfcfa;
  border-radius: 12px 12px 12px 0px;
  padding: 14px 18px;
}
.MessageBubble-module__container___fcY52 .MessageBubble-module__wrapper___zHOQZ .MessageBubble-module__bubble___bU_Zr.MessageBubble-module__right___HQtPY {
  border-radius: 12px 12px 0px 12px;
}
.MessageBubble-module__container___fcY52 .MessageBubble-module__wrapper___zHOQZ .MessageBubble-module__bubble___bU_Zr .MessageBubble-module__bubbleTitle___QhKJJ {
  color: #a79988;
}
.MessageBubble-module__container___fcY52 .MessageBubble-module__wrapper___zHOQZ .MessageBubble-module__bubble___bU_Zr .MessageBubble-module__link___rbtu1 {
  color: #859989;
  display: flex;
}
.MessageBubble-module__container___fcY52 .MessageBubble-module__wrapper___zHOQZ .MessageBubble-module__text___chzT8 {
  color: #859989;
  align-self: flex-end;
}
.MessageBubble-module__container___fcY52 .MessageBubble-module__wrapper___zHOQZ .MessageBubble-module__text___chzT8.MessageBubble-module__right___HQtPY {
  align-self: flex-start;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/TimelineFragment/MessageBubble/MessageBubble.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;AA8pBF;AA5pBE;EACE,2BAAA;EACA,uBAAA;AA8pBJ;AA3pBE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AA6pBJ;AA1pBE;EACE,cAAA;AA4pBJ;AA1pBI;EACE,cAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;AA4pBN;AA1pBM;EACE,iCAAA;AA4pBR;AAzpBM;EACE,cAAA;AA2pBR;AAxpBM;EACE,cAAA;EACA,aAAA;AA0pBR;AAtpBI;EACE,cAAA;EACA,oBAAA;AAwpBN;AAtpBM;EACE,sBAAA;AAwpBR","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n  padding: 0 40px;\n  align-items: baseline;\n\n  &.right {\n    flex-direction: row-reverse;\n    align-items: flex-start;\n  }\n\n  .icon {\n    width: 39px;\n    height: 39px;\n    align-self: flex-end;\n  }\n\n  .wrapper {\n    max-width: 50%;\n\n    .bubble {\n      color: get-color(greenNew, dark);\n      background-color: get-color(grayNew, ultra-light);\n      border-radius: 12px 12px 12px 0px;\n      padding: 14px 18px;\n\n      &.right {\n        border-radius: 12px 12px 0px 12px;\n      }\n\n      .bubbleTitle {\n        color: get-color(orangeNew, medium-dark);\n      }\n\n      .link {\n        color: get-color(greenNew, medium);\n        display: flex;\n      }\n    }\n\n    .text {\n      color: get-color(greenNew, medium);\n      align-self: flex-end;\n\n      &.right {\n        align-self: flex-start;\n      }\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MessageBubble-module__font-s-10___PnP2n`,
	"fontS12": `MessageBubble-module__font-s-12___PsGxA`,
	"fontS13": `MessageBubble-module__font-s-13___H3NKV`,
	"fontS14": `MessageBubble-module__font-s-14___CuJrk`,
	"fontS15": `MessageBubble-module__font-s-15___oa1QJ`,
	"fontS16": `MessageBubble-module__font-s-16___Q58rS`,
	"fontS18": `MessageBubble-module__font-s-18___MFUlo`,
	"fontS20": `MessageBubble-module__font-s-20___l6zw8`,
	"fontS22": `MessageBubble-module__font-s-22___XC7aK`,
	"fontS28": `MessageBubble-module__font-s-28___P7k6Y`,
	"fontW400": `MessageBubble-module__font-w-400___JQbyo`,
	"fontW500": `MessageBubble-module__font-w-500___BG8HU`,
	"fontW600": `MessageBubble-module__font-w-600___CyH3R`,
	"fontW700": `MessageBubble-module__font-w-700___kjWj4`,
	"p5": `MessageBubble-module__p-5___uHPw5`,
	"p12": `MessageBubble-module__p-12___Rvui9`,
	"p16": `MessageBubble-module__p-16___aLfNV`,
	"p30": `MessageBubble-module__p-30___E2zzm`,
	"pB0": `MessageBubble-module__p-b-0___csY4D`,
	"pB5": `MessageBubble-module__p-b-5___Ay83P`,
	"pB10": `MessageBubble-module__p-b-10___Ci4n1`,
	"pB12": `MessageBubble-module__p-b-12___ufi9p`,
	"pB16": `MessageBubble-module__p-b-16___bh7le`,
	"pB18": `MessageBubble-module__p-b-18___MwrQ5`,
	"pB20": `MessageBubble-module__p-b-20___zLriG`,
	"pB25": `MessageBubble-module__p-b-25___R47Ws`,
	"pB30": `MessageBubble-module__p-b-30___DonCt`,
	"pB50": `MessageBubble-module__p-b-50___gvyEx`,
	"pT0": `MessageBubble-module__p-t-0___qyfzx`,
	"pT12": `MessageBubble-module__p-t-12___Aau_l`,
	"pT16": `MessageBubble-module__p-t-16___W2kj7`,
	"pT18": `MessageBubble-module__p-t-18___eE0UV`,
	"pT20": `MessageBubble-module__p-t-20___Zr1HM`,
	"pT30": `MessageBubble-module__p-t-30___kvPGq`,
	"pT40": `MessageBubble-module__p-t-40___kv7IQ`,
	"pT50": `MessageBubble-module__p-t-50___GYbcP`,
	"pL20": `MessageBubble-module__p-l-20___UL2bU`,
	"pL30": `MessageBubble-module__p-l-30___ISRym`,
	"pL40": `MessageBubble-module__p-l-40___arFI6`,
	"pR16": `MessageBubble-module__p-r-16___ctiYF`,
	"pR20": `MessageBubble-module__p-r-20____Mn25`,
	"pR30": `MessageBubble-module__p-r-30___gggJE`,
	"pR50": `MessageBubble-module__p-r-50___vqW2b`,
	"pR60": `MessageBubble-module__p-r-60___Rk70M`,
	"mB1": `MessageBubble-module__m-b-1___gI0vX`,
	"mB2": `MessageBubble-module__m-b-2___WZVNJ`,
	"mB6": `MessageBubble-module__m-b-6___Y6Wl5`,
	"mB8": `MessageBubble-module__m-b-8___lv5PK`,
	"mB10": `MessageBubble-module__m-b-10___LESm7`,
	"mB14": `MessageBubble-module__m-b-14___sFwvv`,
	"mB16": `MessageBubble-module__m-b-16___ZpyGl`,
	"mB20": `MessageBubble-module__m-b-20____dda5`,
	"mB22": `MessageBubble-module__m-b-22___ZzT7y`,
	"mB24": `MessageBubble-module__m-b-24___nR6fT`,
	"mB30": `MessageBubble-module__m-b-30___b85za`,
	"mB32": `MessageBubble-module__m-b-32___kNtyi`,
	"mB40": `MessageBubble-module__m-b-40___NS6_I`,
	"mT2": `MessageBubble-module__m-t-2___cv9en`,
	"mT3": `MessageBubble-module__m-t-3___wvEAW`,
	"mT4": `MessageBubble-module__m-t-4___mCAiE`,
	"mT5": `MessageBubble-module__m-t-5___i1JUi`,
	"mT8": `MessageBubble-module__m-t-8___KoQRw`,
	"mT10": `MessageBubble-module__m-t-10___h4b6x`,
	"mT15": `MessageBubble-module__m-t-15___TW4HY`,
	"mT16": `MessageBubble-module__m-t-16___UFSGW`,
	"mT20": `MessageBubble-module__m-t-20___hONpb`,
	"mT22": `MessageBubble-module__m-t-22___jkTfH`,
	"mT30": `MessageBubble-module__m-t-30___lB1u5`,
	"mT32": `MessageBubble-module__m-t-32___zu6Oq`,
	"mLAuto": `MessageBubble-module__m-l-auto___XkV7p`,
	"mL4": `MessageBubble-module__m-l-4___wM23X`,
	"mL5": `MessageBubble-module__m-l-5___wW4qA`,
	"mL6": `MessageBubble-module__m-l-6___spLqw`,
	"mL8": `MessageBubble-module__m-l-8___rD8XG`,
	"mL10": `MessageBubble-module__m-l-10___UmGYH`,
	"mL16": `MessageBubble-module__m-l-16___tvmAc`,
	"mL20": `MessageBubble-module__m-l-20___O_9wT`,
	"mL24": `MessageBubble-module__m-l-24___xNceL`,
	"mL30": `MessageBubble-module__m-l-30___CayEu`,
	"mL35": `MessageBubble-module__m-l-35___l5nOy`,
	"mL40": `MessageBubble-module__m-l-40___OR_1Q`,
	"mR8": `MessageBubble-module__m-r-8___dWpat`,
	"mR10": `MessageBubble-module__m-r-10___bEfOq`,
	"mR16": `MessageBubble-module__m-r-16___vH8pf`,
	"mR20": `MessageBubble-module__m-r-20___xeZjk`,
	"mR24": `MessageBubble-module__m-r-24___cGY1H`,
	"mR30": `MessageBubble-module__m-r-30___cmWse`,
	"mR40": `MessageBubble-module__m-r-40___iFLHp`,
	"borderR3": `MessageBubble-module__border-r-3___L46Af`,
	"borderR4": `MessageBubble-module__border-r-4___gl1JN`,
	"borderR6": `MessageBubble-module__border-r-6___yi0zJ`,
	"borderR10": `MessageBubble-module__border-r-10___i35Y0`,
	"borderR12": `MessageBubble-module__border-r-12___DSHjP`,
	"borderR16": `MessageBubble-module__border-r-16___fw5Wd`,
	"borderR50": `MessageBubble-module__border-r-50___X9P1V`,
	"primaryBorder": `MessageBubble-module__primary-border___bsMF0`,
	"primaryBorderB": `MessageBubble-module__primary-border-b___QCOvj`,
	"primaryBorderT": `MessageBubble-module__primary-border-t___fNz09`,
	"primaryBorderL": `MessageBubble-module__primary-border-l___jtMIp`,
	"primaryBorderR": `MessageBubble-module__primary-border-r___BbYYm`,
	"secondaryBorder": `MessageBubble-module__secondary-border___lJPHI`,
	"secondaryBorderB": `MessageBubble-module__secondary-border-b___n1feG`,
	"secondaryBorderT": `MessageBubble-module__secondary-border-t___n8bsg`,
	"secondaryBorderL": `MessageBubble-module__secondary-border-l___jol4w`,
	"secondaryBorderR": `MessageBubble-module__secondary-border-r___AU688`,
	"gap0": `MessageBubble-module__gap-0___Ed4Wm`,
	"gap2": `MessageBubble-module__gap-2___UMqlM`,
	"gap4": `MessageBubble-module__gap-4___Bk16J`,
	"gap5": `MessageBubble-module__gap-5___beqev`,
	"gap6": `MessageBubble-module__gap-6___B7bWl`,
	"gap8": `MessageBubble-module__gap-8___AtUo5`,
	"gap10": `MessageBubble-module__gap-10___rXvs_`,
	"gap12": `MessageBubble-module__gap-12___m3u9k`,
	"gap14": `MessageBubble-module__gap-14___ppx6q`,
	"gap16": `MessageBubble-module__gap-16___h0M8s`,
	"gap18": `MessageBubble-module__gap-18___LPXVt`,
	"gap20": `MessageBubble-module__gap-20___ihpcU`,
	"gap24": `MessageBubble-module__gap-24___QnIQP`,
	"gap26": `MessageBubble-module__gap-26___siZPQ`,
	"gap30": `MessageBubble-module__gap-30___vzMkc`,
	"gap32": `MessageBubble-module__gap-32___DQJcp`,
	"gap40": `MessageBubble-module__gap-40___YZMWa`,
	"gap50": `MessageBubble-module__gap-50___hK6D8`,
	"flex1": `MessageBubble-module__flex-1___qgToY`,
	"flexNone": `MessageBubble-module__flex-none___mK3f3`,
	"flexColumn": `MessageBubble-module__flex-column___HYjzF`,
	"flexRow": `MessageBubble-module__flex-row___hOquD`,
	"verticallyCentered": `MessageBubble-module__vertically-centered___srWQ9`,
	"horizontallyCentered": `MessageBubble-module__horizontally-centered___BChgs`,
	"horizontallyEnd": `MessageBubble-module__horizontally-end___z0HWk`,
	"verticallyStart": `MessageBubble-module__vertically-start___x5hgq`,
	"spaceBetween": `MessageBubble-module__space-between___q32xM`,
	"flexWrap": `MessageBubble-module__flex-wrap___W7IQX`,
	"height100": `MessageBubble-module__height-100___iyA5D`,
	"width50": `MessageBubble-module__width-50___d4Fv7`,
	"width100": `MessageBubble-module__width-100___Vc0ys`,
	"cursorPointer": `MessageBubble-module__cursor-pointer___Ht8ve`,
	"cursorNotAllowed": `MessageBubble-module__cursor-not-allowed___LlyKy`,
	"absoluteCentered": `MessageBubble-module__absolute-centered___Cao_G`,
	"absolute": `MessageBubble-module__absolute___neGOw`,
	"relative": `MessageBubble-module__relative___j85oN`,
	"fixed": `MessageBubble-module__fixed___Dshho`,
	"visible": `MessageBubble-module__visible___g7NfV`,
	"invisible": `MessageBubble-module__invisible___ccx9s`,
	"col90": `MessageBubble-module__col-90___Hmjkw`,
	"colAuto": `MessageBubble-module__col-auto___UFPOv`,
	"medicalTabs": `MessageBubble-module__medical-tabs___UTThH`,
	"medicalTableNew": `MessageBubble-module__medical-table-new___d3pAz`,
	"noPagination": `MessageBubble-module__no-pagination___rBVkx`,
	"medicalTableEmpty": `MessageBubble-module__medical-table-empty___Ga1ld`,
	"iconBtn": `MessageBubble-module__icon-btn___yaTsA`,
	"searchIcon": `MessageBubble-module__search-icon___h6UKf`,
	"disableSelect": `MessageBubble-module__disable-select___DBxdn`,
	"breakWord": `MessageBubble-module__break-word___aD4j1`,
	"popupClearBtn": `MessageBubble-module__popup-clear-btn___RKkLr`,
	"scrollMB20": `MessageBubble-module__scroll-m-b-20___bgkwZ`,
	"container": `MessageBubble-module__container___fcY52`,
	"right": `MessageBubble-module__right___HQtPY`,
	"icon": `MessageBubble-module__icon___PgfpR`,
	"wrapper": `MessageBubble-module__wrapper___zHOQZ`,
	"bubble": `MessageBubble-module__bubble___bU_Zr`,
	"bubbleTitle": `MessageBubble-module__bubbleTitle___QhKJJ`,
	"link": `MessageBubble-module__link___rbtu1`,
	"text": `MessageBubble-module__text___chzT8`
};
module.exports = ___CSS_LOADER_EXPORT___;
